var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropdown-controls"},[_vm._m(0),_vm._v(" "),_c('nav',{staticClass:"controls-nav"},[_c('ul',[_vm._t("default")],2)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"controls-button",attrs:{"aria-expanded":"false","aria-haspopup":"true","type":"button","data-toggle":"dropdown"}},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])
}]

export { render, staticRenderFns }